import { NewWindowAnchor } from '@xo-union/component-standard-elements';
import Icon from '@xo-union/tk-component-icons';
import { IconName } from '@xo-union/dist-iconography';
import React from 'react';

import styles from './actionItem.scss';

interface Props {
  children: any;
  type: 'add' | 'remove' | 'removeBlue';
  iconSize?: 'sm' | 'md' | 'lg';
  // @ts-ignore
  onClick: (e) => void;
}

const SPACE_CHAR_CODE = 32;
const supportedTypes = {
  add: 'add_circle',
  remove: 'delete',
  removeBlue: 'delete',
};

export const ActionItem: React.FC<Props> = ({ children, type, iconSize = 'md', onClick }) => {
  const iconName = supportedTypes[type] as IconName;
  const className = `${styles.actionItem} ${styles[type]}`;

  return (
    <NewWindowAnchor
      className={className}
      tabIndex="0"
      onClick={onClick}
      // @ts-ignore
      onKeyDown={(e): void | boolean => e.charCode === SPACE_CHAR_CODE && onClick(e)}
    >
      <Icon data-testid={`${type}-icon`} className={styles.actionIcon} size={iconSize} name={iconName} />
      {children}
    </NewWindowAnchor>
  );
};
